// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Creator } from "./Creator";
import {
  CreatorFromJSON,
  CreatorFromJSONTyped,
  CreatorToJSON,
  CreatorToJSONTyped,
} from "./Creator";

/**
 *
 * @export
 * @interface CommentEventCreate
 */
export interface CommentEventCreate {
  /**
   *
   */
  creator?: Creator | null;
}

/**
 * Check if a given object implements the CommentEventCreate interface.
 */
export function instanceOfCommentEventCreate(value: object): value is CommentEventCreate {
  return true;
}

export function CommentEventCreateFromJSON(json: any): CommentEventCreate {
  return CommentEventCreateFromJSONTyped(json, false);
}

export function CommentEventCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommentEventCreate {
  if (json == null) {
    return json;
  }
  return {
    creator:
      json["creator"] === undefined
        ? undefined
        : json["creator"] === null
        ? null
        : CreatorFromJSON(json["creator"]),
  };
}

export function CommentEventCreateToJSON(json: any): CommentEventCreate {
  return CommentEventCreateToJSONTyped(json, false);
}

export function CommentEventCreateToJSONTyped(
  value?: CommentEventCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    creator: CreatorToJSON(value["creator"]),
  };
}
